import React from 'react';
import { Outlet } from 'react-router-dom';
import { WorkspaceProvider } from '../context/WorkspaceContext';
import { TemplateCacheProvider } from '../hooks/useTemplateCache';
import SideMenu from '../components/navigation/SideMenu';

const WorkspaceLayout: React.FC = () => {
  return (
    <WorkspaceProvider>
      <TemplateCacheProvider>
      <div className="flex h-screen bg-cm-bg-deep text-cm-text-primary">
        {/* Side Navigation */}
        <SideMenu className="flex-shrink-0" />

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Page Content */}
          <main className="flex-1 overflow-auto p-4">
            <Outlet />
          </main>
        </div>
      </div>
      </TemplateCacheProvider>
    </WorkspaceProvider>
  );
};

export default WorkspaceLayout;
